import { createSlice } from '@reduxjs/toolkit';
import { revertAll } from '../actions';

export type IApiCall = {
    page: number;
};

const initialState: IApiCall = {
    page: 1,
};

const apiCallSlice = createSlice({
    name: 'apiCall',
    initialState,
    reducers: {
        updateRefetchApiCall: (state, action) => {
            const page = action?.payload?.page || 1;
            return {
                ...state,
                page,
            };
        },
    },
    extraReducers: builder => builder.addCase(revertAll, () => initialState),
});

export const { updateRefetchApiCall } = apiCallSlice.actions;

export const apiCallReducer = apiCallSlice.reducer;
